<template>
  <div class="row queued-upload align-center py-1 hover-parent">
    <!-- If value is set, upload is ready -->
    <template v-if="uploaded">
      <v-icon light>
fa-{{ value.mime | MimeIcon }}
</v-icon>
      <small class="mx-2 no-selection cursor-pointer flex" @click="open()">{{ value.name
      }}<!--  ({{value.size | PrettySize}}) --></small>
      <v-icon
        v-if="!disabled"
        class="remove-upload mr-2 hover-show"
        light
        @click="remove()"
      >
        close
      </v-icon>
    </template>

    <!-- If value is not yet set and upload has not began, allow upload -->
    <template v-else-if="uploading">
      <!-- Is queued, waiting, or is uploading... -->
      <v-progress-linear
        :value="progress"
        height="4"
        color="blue lighten-1"
        :indeterminate="upload.status != 'executing' || progress == 100"
      />
      <small v-if="upload.status == 'executing'" class="mx-2">{{ progress }}%</small>
      <small v-else class="mx-2">aguardando</small>

      <v-icon class="remove-upload mr-2 hover-show" light @click="remove()">
        close
      </v-icon>
      <!-- uploading... status: <code>{{upload.status}}</code> -->
    </template>

    <template v-else-if="failed">
      <v-icon class="mr-2 red--text" style="font-size: 12px" light>
        error
      </v-icon>
      <small class="red--text mr-2">Ocorreu uma falha: {{ upload.error }}</small>
      <v-icon class="remove-upload mr-2" light @click="remove()">
        close
      </v-icon>
    </template>

    <template v-else>
      <input
        ref="inputFile"
        class="hidden"
        type="file"
        @change="didSelectFile($event)"
      >
      <el-button
        style="height: 36px"
        icon="el-icon-upload2"
        class="tournament-light-blue tournament-white--text rounded no-border no-selection"
        @click="openUpload()"
      >
        SELECIONAR ARQUIVOS
      </el-button>
    </template>
  </div>
</template>

<script>
import Uploader from "@/services/Uploader";

export default {
  name: "QueuedUpload",

  model: {
    prop: "value",
    event: "upload",
  },

  props: {
    value: {
      type: Object,
      default: null,
    },

    onUpload: {
      type: Function,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    // groupKey: {
    //   type: String,
    //   default: null,
    // },

    // upload: {
    //   type: Object,
    //   default: null,
    // },
  },

  data: function () {
    return {
      upload: null,
    };
  },

  computed: {
    uploaded() {
      return !!(this.value && this.value.path);
    },

    uploading() {
      return !this.uploaded && this.upload && this.upload.running;
    },

    failed() {
      return (
        !this.uploaded &&
        this.upload &&
        (this.upload.status == "failed" || this.upload.status == "canceled")
      );
    },

    progress() {
      const progress = this.upload ? this.upload.progress : 0;
      return progress ? Math.floor(progress * 100) : 0;
    },
  },

  watch: {
    // Override internal upload variable if it changed
    "value.$upload": function (upload) {
      this.upload = upload;
    },
  },

  created() {
    // Try recovering last upload in case key is set and value is not
    this.upload = (this.value && this.value.$upload) || null;
  },

  methods: {
    remove() {
      if (this.upload && this.upload.running) {
        this.upload.cancel();
      }

      this.upload = null;

      this.$emit("remove");
    },

    open() {
      if (this.value && this.value.url) {
        window.open(this.value.url);
      }
    },

    openUpload() {
      this.$refs.inputFile.click();
    },

    didSelectFile($event) {
      const file = $event.target.files && $event.target.files[0];
      if (!file) return;

      this.$emit("selected", file);

      const upload = (this.upload = Uploader.upload(file));

      const key = String(Math.random());
      const newValue = {
        $key: key,
        name: file.name,
        path: null,
        mime: null,
        $upload: upload,
      };

      // Add $upload to the model
      this.$emit("upload", newValue);

      // Save in case component get's unmountent
      // let onUpload = this.onUpload
      upload.promise.then((info) => {
        // onUpload && onUpload(info)
        Object.assign(newValue, info);
        this.upload = null;
        this.$emit("uploaded", newValue);
        this.$emit("upload", newValue);
      });
    },
  },
};
</script>

<style>
.queued-upload {
  min-height: 40px;
}

.remove-upload {
  font-size: 12px;
  cursor: pointer;
}

.upload-button {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 32px;
  border-radius: 4px;
  background-color: #f6f9fb;
  border: dashed 1px #55d0e9;

  font-family: Ubuntu;
  font-size: 12px;
  font-weight: 500;
  color: #3bbed9;
}

.upload-button .icon {
  font-size: 20px;
  font-weight: 500;
  color: #3bbed9;
}
</style>



// WEBPACK FOOTER //
// src/components/QueuedUpload.vue